import React from 'react';
import AuthStore from 'auth-store';

import { useGetGeneralInfo, useGetBusinessInfo } from '../hooks';
import MerchantGeneralInfo from './MerchantGeneralInfo';
import MerchantBusinessInfo from './MerchantBusinessInfo';

function MerchantDetail() {
  const [isGeneralInfoLoading, generalInfo] = useGetGeneralInfo();
  const [isBusinessInfoLoading, businessInfo] = useGetBusinessInfo();
  const userRole = AuthStore.get('_role');
  return (
    <div className="space-y-4">
      <div className="bg-white rounded-lg border shadow-primary-sm p-6">
        <MerchantGeneralInfo
          data={generalInfo}
          isLoading={isGeneralInfoLoading}
          role={userRole}
        />
        {generalInfo?.business_type ? (
          <MerchantBusinessInfo
            type={generalInfo?.business_type}
            data={businessInfo}
            isLoading={isBusinessInfoLoading}
          />
        ) : null}
      </div>
    </div>
  );
}

MerchantDetail.propTypes = {};

export default MerchantDetail;
